/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getLoginUser } from './loginService';
import { isCallcenterLoggedIn, getCallcenterUser } from './callcenterService';

const baseUrl = `${process.env.BACKEND_API_BASE_URL}/jobs.php`;

const getToken = () => (isCallcenterLoggedIn() ? getCallcenterUser() : getLoginUser()).token;

// The server refuses answers this close to the deadline (pergoapi
// MILESTONE_RADIUS_ANSWER_GRACE_SEC) — the driver's phone may already be
// showing "no response" — so the portal stops offering Approve / Deny then too.
export const RADIUS_APPROVAL_ANSWER_GRACE_SEC = 5;

// A poll that was already in flight when this page answered a request returns
// the pre-answer list — JobTableSection drops such responses.
let lastResolveAt = 0;
export const noteRadiusApprovalResolved = () => {
  lastResolveAt = Date.now();
};
export const radiusApprovalPollIsStale = startedAt => startedAt <= lastResolveAt;

// Seconds left before the driver may proceed without an answer. expires_in is
// the server's count at poll time; received_at is when this page got it.
export const radiusApprovalRemainingSec = (request, now = Date.now()) => {
  if (!request) return 0;
  const expiresIn = parseInt(request.expires_in, 10);
  if (!Number.isFinite(expiresIn)) return 0;
  const elapsed = request.received_at ? Math.max(0, Math.floor((now - request.received_at) / 1000)) : 0;
  return Math.max(0, expiresIn - elapsed);
};

export const formatMinSec = seconds => {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const radiusMilestoneLabel = request => (request?.milestone === 'dropoff' ? 'Drop Off' : 'Pick Up');

// Identity of a request on this page. Each base numbers its requests from 1,
// so on the call-center page (several bases) the id alone is ambiguous.
export const radiusApprovalKey = request => `${request?.fetched_db || ''}:${request?.id}`;

export const radiusApprovalService = {
  // Pending out-of-radius Pick Up / Drop Off requests — polled to drive the banner/dialog.
  get_radius_approvals: async (data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'get_radius_approvals',
        token: getToken(),
        ...data, // { dbname } for call center
      },
    }),
  // decision: 'approve' | 'deny'. The first answer wins; the server pushes it to the driver.
  resolve_radius_approval: async (requestId, decision, data = {}) =>
    axios.get(baseUrl, {
      params: {
        method: 'resolve_radius_approval',
        request_id: requestId,
        decision,
        token: getToken(),
        ...data,
      },
    }),
};
